import { Injectable } from '@angular/core';
import { ConflictImageDialogOptions, ImageConflictDialogComponent } from './image-conflict-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConflictImage } from '../../../_objects/inspection-image';

@Injectable({
  providedIn: 'root'
})
export class ImageConflictDialogService {

  private _dialogRef: MatDialogRef<ImageConflictDialogComponent, boolean>;
  public conflictImageList: ConflictImage[] = [];

  get dialogRef() {
    return this._dialogRef;
  }

  get isOpened () {
    return this._dialogRef && this._dialogRef.componentInstance;
  }
  constructor(private dialog: MatDialog) { }

  public open(conflictImageList: ConflictImage[], options: ConflictImageDialogOptions = { applyToAllEnabled: true, cancelEnabled: true }) {
    if (this.isOpened) {
      return this._dialogRef;
    }

    this.conflictImageList = conflictImageList;
    this._dialogRef = this.dialog.open(ImageConflictDialogComponent, {
      width: '600px',
      minHeight: '385px',
      disableClose: true,
      data: {
        conflictImage: this.conflictImageList[0],
        options 
      }
    });

    return this._dialogRef;
  }

  public close() {
    if (!this._dialogRef) {
      return;
    }
    this._dialogRef.close(true);
    this._dialogRef = null;
  }

  public nextConflictImage() {
    this.conflictImageList.shift();

    if (this.conflictImageList.length > 0) {
      this._dialogRef.componentInstance.nextConflict(this.conflictImageList[0]);
    } else {
      this.close();
    }
  }
}
